<script setup lang="ts">
import { supabase } from '@/composables/supabaseClient'
import toastThrowError from '@/helpers/toastThrowError'
import uuidv7 from '@/helpers/uuidv7'
import { useDatabaseStore } from '@/stores/databaseStore'
import { computed } from 'vue'
import type { DataTableColumn } from './BaseDataTable.vue'
import BaseDataTable from './BaseDataTable.vue'

const databaseStore = useDatabaseStore()

const rows = computed(() => {
  return databaseStore.unitsOfMeasure ?? []
})
type RowType = (typeof rows.value)[number]
const columns: DataTableColumn<RowType>[] = [
  {
    columnDataKey: 'code',
    name: 'Code',
    defaultWidth: 150,
  },
  {
    columnDataKey: 'description',
    name: 'Description',
    defaultWidth: 300,
  },
]

async function addUOM(row: RowType) {
  const { data, error } = await supabase
    .from('unit_of_measure')
    .insert({ id: uuidv7(), code: row.code, description: row.description })
    .select()
    .single()
  if (error) throw toastThrowError('Error saving new UOM', error)
  databaseStore.unitsOfMeasure?.push(data)
}

async function updateUOM(row: RowType) {
  const result = await supabase
    .from('unit_of_measure')
    .update({ code: row.code, description: row.description })
    .eq('id', row.id)
    .select()
    .single()
  if (result.error) throw toastThrowError('Error updating UOM', result.error)
  const index = databaseStore.unitsOfMeasure?.findIndex((uom) => uom.id === row.id)
  if (index === undefined) throw toastThrowError('Unable to update uom locally. Refresh page.')
  databaseStore.unitsOfMeasure?.splice(index, 1, result.data)
}
</script>

<template>
  <div class="flex h-full w-full flex-col gap-3 p-3">
    <BaseDataTable
      table-name="DBEquipment"
      :columns="columns"
      :rows="rows"
      row-key="id"
      @row-update="updateUOM"
      show-new-row
      show-row-actions
      allow-import
      @add-new-row="addUOM"
    >
    </BaseDataTable>
  </div>
</template>
